import { render, staticRenderFns } from "./StarView.vue?vue&type=template&id=7b58f8ad"
import script from "./StarView.vue?vue&type=script&lang=js"
export * from "./StarView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports